import { render, staticRenderFns } from "./SystemNotificationsInfoModal.vue?vue&type=template&id=a6d1eae0&scoped=true&"
import script from "./SystemNotificationsInfoModal.vue?vue&type=script&lang=ts&"
export * from "./SystemNotificationsInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./SystemNotificationsInfoModal.vue?vue&type=style&index=0&id=a6d1eae0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d1eae0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VExpansionPanels,VIcon,VSpacer})
